import { graphql } from 'gatsby';
import PropTypes from 'prop-types';
import React from 'react';

import './grid.styl';

import ProductLinkImage from '../views/components/ProductLinkImage';
import MainLayout from '../views/layouts/MainLayout';
import { mapOrder } from '../utils/array';

const GridPage = ({ data }) => {
    const { kitchens, pictures } = data;

    const list = kitchens.edges.map((n) => n.node);
    const picturesList = pictures.edges.map((n) => n.node);

    const order = [
        'balsamita',
        'chia',
        'stevia',
        'alpinia',
        'artemisia',
        'garcinia',
        'pachira',
        'pasilla',
        'verbena',
    ];
    const sortedList = mapOrder(list, order, 'slug');

    return (
        // eslint-disable-next-line react/jsx-filename-extension
        <MainLayout>
            <div className='grid-bloc'>
                {sortedList.map((item, i) => (
                    <ProductLinkImage
                        // eslint-disable-next-line react/no-array-index-key
                        key={`grid-item-${i}`}
                        index={i}
                        item={item}
                        pictures={picturesList}
                        total={sortedList.length}
                        isSmall
                    />
                ))}
            </div>
        </MainLayout>
    );
};

GridPage.propTypes = {
    data: PropTypes.object.isRequired,
};

export default GridPage;

export const query = graphql`
    query {
        pictures: allFile(filter: { sourceInstanceName: { eq: "kitchens" } }) {
            edges {
                node {
                    ...ImageGrid
                }
            }
        }
        kitchens: allKitchensCsv {
            edges {
                node {
                    ...KitchenSlide
                }
            }
        }
    }
`;
